import BackofficeController from "backoffice_controller";
import { passCsrfToken } from "../util/helpers";
import axios from "axios";

export default class extends BackofficeController {
  static targets = ["categories", "exportButton", "name"];

  connect() {
    passCsrfToken(document, axios);
    this.params = {
      categories: "",
      name: "",
    };
    this.updateCategories();
    this.updateName();
    this._checkIfExcelButtonShouldBeSeen();
  }

  updateName() {
    this.params.name = this.nameTarget.value;
    this._checkIfExcelButtonShouldBeSeen();
    this._updateRequestUrl();
  }

  updateCategories() {
    this.params.categories = this.categoriesTarget.value;
    this._checkIfExcelButtonShouldBeSeen();
    this._updateRequestUrl();
  }

  _updateRequestUrl() {
    const ids = this.params.categories;
    const name = this.params.name;
    this.exportButtonTarget.href = `/bo/generate_xls_template?categories=${ids}&name=${name}`;
  }

  _checkIfExcelButtonShouldBeSeen() {
    if (this.params.categories == "") {
      this.exportButtonTarget.classList.add("disabled");
    } else {
      this.exportButtonTarget.classList.remove("disabled");
    }
  }
}
